module.exports = __webpack_public_path__ + "source/img/thumb-up-line.57bace6c.svg";